import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import PageHeader from "../../components/ui/PageHeader";
import JournalEntryList from "../../components/accounting/JournalEntryList";
import JournalEntryForm from "../../components/accounting/JournalEntryForm";
import JournalEntryDetail from "../../components/accounting/JournalEntryDetail";
import { useParams, useNavigate } from "react-router-dom";

const JournalEntriesPage = () => {
  const { entryId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleView = (entry) => {
    navigate(`/accounting/journal/${entry.id}`);
  };

  const handleEdit = (entry) => {
    setEditingEntry(entry);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingEntry(null);
    setRefreshKey((k) => k + 1);
  };

  if (entryId) {
    return (
      <JournalEntryDetail
        entryId={entryId}
        onEdit={handleEdit}
        onBack={() => navigate("/accounting/journal")}
      />
    );
  }

  return (
    <Box>
      <PageHeader
        title="Asientos Contables"
        subtitle="Libro Diario - Todos los asientos del sistema"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingEntry(null);
              setShowForm(true);
            }}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
            }}
          >
            Nuevo Asiento Manual
          </Button>
        }
      />

      <JournalEntryList
        key={refreshKey}
        onView={handleView}
        onEdit={handleEdit}
      />

      <Dialog
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingEntry(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: "24px", maxHeight: "90vh" } }}
      >
        <DialogContent sx={{ p: 0 }}>
          <JournalEntryForm
            entry={editingEntry}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingEntry(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default JournalEntriesPage;
